let observer;
document.addEventListener("DOMContentLoaded", () => {
  const targetNode = document.querySelector(".product__media-wrapper");

  if (!targetNode) return;

  let debounceTimeout;
  observer = new MutationObserver(() => {
    clearTimeout(debounceTimeout);
    debounceTimeout = setTimeout(() => {
      initSliders();
    }, 200);
  });

  observer.observe(targetNode, { childList: true, subtree: true });

  initSliders();
});

function initSliders() {
  if (typeof $.fn.slick !== "function") {
    return;
  }
  if (observer) observer.disconnect();

  const $main = $(".product-slick");
  const $nav = $(".product-slick-nav");

  if ($main.length && $main.hasClass("slick-initialized")) {
    $main.slick("unslick");
  }

  if ($nav.length && $nav.hasClass("slick-initialized")) {
    $nav.slick("unslick");
  }

  if ($main.length) {
    $main.slick({
      slidesToScroll: 1,
      slidesToShow: 1,
      arrows: true,
      nextArrow: $(".prod-icon-next"),
      prevArrow: $(".prod-icon-prev"),
      dots: false,
      asNavFor: ".product-slick-nav",
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            variableWidth: false,
          },
        },
      ],
    });
  }

  if ($nav.length) {
    $nav.slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      asNavFor: ".product-slick",
      dots: false,
      arrows: false,
      focusOnSelect: true,
      variableWidth: true,
    });
  }

  const targetNode = document.querySelector(".product__media-wrapper");
  if (targetNode) {
    observer.observe(targetNode, { childList: true, subtree: true });
  }
}
